/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { action } from 'typesafe-actions';

import { ConfigActionTypes } from './types';

export const getConfigRecord = (university: string) => action(ConfigActionTypes.GET_UNI_CONFIG, { university });
export const getConfigRecordSuccess = (config: any) => action(ConfigActionTypes.GET_UNI_CONFIG_SUCCESS, config);
export const getConfigRecordFailure = (error: string) => action(ConfigActionTypes.GET_UNI_CONFIG_FAILURE, error);

export const refreshConfigRecord = () => action(ConfigActionTypes.REFRESH_UNI_CONFIG);

export const saveConfig = (conf: any) => action(ConfigActionTypes.SAVE_CONFIG, { ...conf });
export const saveConfigSuccess = (config: any) => action(ConfigActionTypes.SAVE_CONFIG_SUCCESS, config);
export const saveConfigFailure = (message: string) => action(ConfigActionTypes.SAVE_CONFIG_FAILURE, message);

export const importSSHPubKey = (sshKey: any) => action(ConfigActionTypes.IMPORT_SSH_PUB_KEY, sshKey);
export const importSSHPubKeySuccess = (response: any) => action(ConfigActionTypes.IMPORT_SSH_PUB_KEY_SUCCESS, response);
export const importSSHPubKeyFailure = (message: string) =>
  action(ConfigActionTypes.IMPORT_SSH_PUB_KEY_FAILURE, message);

export const saveCalendlyConfig = (CalendlyConfig: any) =>
  action(ConfigActionTypes.SAVE_CALENDLY_CONFIG, CalendlyConfig);
export const saveCalendlyConfigSuccess = (config: any) =>
  action(ConfigActionTypes.SAVE_CALENDLY_CONFIG_SUCCESS, config);
export const saveCalendlyConfigFailure = (message: string) =>
  action(ConfigActionTypes.SAVE_CALENDLY_CONFIG_FAILURE, message);

export const getUniRegionInterviewConfig = (university: string, pathway?: string) =>
  action(ConfigActionTypes.GET_UNI_REGION_INTERVIEW_CONFIG, { university, pathway });
export const getUniRegionInterviewConfigSuccess = (config: any) =>
  action(ConfigActionTypes.GET_UNI_REGION_INTERVIEW_CONFIG_SUCCESS, config);
export const getUniRegionInterviewConfigFailure = (error: string) =>
  action(ConfigActionTypes.GET_UNI_REGION_INTERVIEW_CONFIG_FAILURE, error);

export const getPartner = (name: string) => action(ConfigActionTypes.GET_PARTNER_CONFIG_BY_NAME, name);
export const getPartnerByNameSuccess = (partner: any) =>
  action(ConfigActionTypes.GET_PARTNER_CONFIG_BY_NAME_SUCCESS, partner);
export const getPartnerByNameFailure = (error: string) =>
  action(ConfigActionTypes.GET_PARTNER_CONFIG_BY_NAME_FAILURE, error);

export const getNavigationUrls = (university: string) => action(ConfigActionTypes.GET_NAVIGATION_URLS, { university });
export const getNavigationUrlsSuccess = (urls: any) => action(ConfigActionTypes.GET_NAVIGATION_URLS_SUCCESS, urls);
export const getNavigationUrlsFailure = (error: string) => action(ConfigActionTypes.GET_NAVIGATION_URLS_FAILURE, error);

export const getFeatureFlagsData = () => action(ConfigActionTypes.GET_FEATURE_FLAGS_DATA);

export const getFeatureFlagsDataSuccess = (featureFlags: { [key: string]: boolean }) =>
  action(ConfigActionTypes.GET_FEATURE_FLAGS_DATA_SUCCESS, { featureFlags });

export const getFeatureFlagsDataFailure = (error: unknown) =>
  action(ConfigActionTypes.GET_FEATURE_FLAGS_DATA_FAILURE, error);
export const getAdmAllowedAliases = () => action(ConfigActionTypes.GET_ADM_ALLOWED_ALIASES);
export const getAdmAllowedAliasesSuccess = (allowedAliases: string[]) =>
  action(ConfigActionTypes.GET_ADM_ALLOWED_ALIASES_SUCCESS, allowedAliases);
export const getAdmAllowedAliasesFailure = (error: string) =>
  action(ConfigActionTypes.GET_ADM_ALLOWED_ALIASES_FAILURE, error);
